import qs from 'qs';
import {
  OnboardingResponseRoleEnum,
  UserResponse,
  UserResponseAgentStatusEnum,
} from '../openapi/yenta';

export const getFullName = <
  T extends { firstName?: string; lastName?: string },
>(
  user: T,
): string => {
  if (!user) {
    return 'N/A';
  }

  return `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
};

export const getLoanOfficerFullName = <
  T extends { firstName?: string; lastName?: string },
>(
  user: T,
  loanOfficer: T,
): string => {
  if (user?.firstName === 'System' && user?.lastName === 'User') {
    return getFullName(loanOfficer);
  }

  return getFullName(user);
};

export const scrollToBottom = (containerElement: HTMLElement) => {
  containerElement?.scrollTo(0, containerElement.scrollHeight!);
};

export const delay = async (ms: number) =>
  new Promise<void>((resolve) => setTimeout(() => resolve(), ms));

export const getPathWithQueryParams = (
  path: string,
  queryParams: Record<string, string | undefined>,
) => {
  if (Object.keys(queryParams).length === 0) {
    return path;
  }

  const params = Object.keys(queryParams).reduce((filteredParams, key) => {
    const value = queryParams[key];
    if (value) {
      return {
        ...filteredParams,
        [key]: value,
      };
    }
    return filteredParams;
  }, {});

  if (Object.keys(params).length === 0) {
    return path;
  }

  return `${path}?${qs.stringify(params)}`;
};

export const isRBOFeatureEnabled = (userDetail?: UserResponse) => {
  const isSherlockApplicationIdAvailable = (
    userDetail?.onboardings || []
  )?.find(
    (onboarding) =>
      onboarding?.role === OnboardingResponseRoleEnum.Agent &&
      userDetail?.agentStatus === UserResponseAgentStatusEnum.Candidate,
  )?.sherlockApplicationId;

  return !!isSherlockApplicationIdAvailable;
};
